import notification from 'antd/lib/notification'

export default {
  show (type, message, description) {
    notification.config({ top: 120 })
    notification[type]({ message, description })
  }
}
